/**
 * Represents the zeus.apollon_fk_conf.conf.kontakte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { KontaktConfig } from '@/models/apollon_conf_fk/KontaktConfig';

export class Kontakte extends Model {
    eigentuemer: KontaktConfig | null = null;
    unternehmer: KontaktConfig | null = null;
    kontakt: KontaktConfig | null = null;
    bevollmaechtigter: KontaktConfig | null = null;
    infotext: string | null = null;

    public mutations(): MutationsObject {
        return {
            eigentuemer: (val: KontaktConfig) => createModel(KontaktConfig, val),
            unternehmer: (val: KontaktConfig) => createModel(KontaktConfig, val),
            kontakt: (val: KontaktConfig) => createModel(KontaktConfig, val),
            bevollmaechtigter: (val: KontaktConfig) => createModel(KontaktConfig, val)
        };
    }
}
